import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { XToggleContent } from '@adornis/chemistry/elements/components/x-toggle-content.js';
import { html, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * @customElement cr-nospace-toggle-content
 */
@customElement('cr-nospace-toggle-content')
export class CrNospaceToggleContent extends XToggleContent {
  @property({ attribute: true, type: Boolean }) public small?;

  protected override _contentWrapper() {
    return html`
      <x-flex
        tabindex="0"
        id="content"
        ${css({
          ...(this.open
            ? {
                height: 'unset',
                paddingTop: this.small ? this.spacing.xs : this.spacing.sm,
                paddingBottom: this.spacing.md,
              }
            : { height: '0', opacity: '0', pointerEvents: 'none', overflow: 'hidden' }),
        })}
      >
        ${this._content()}
      </x-flex>
    `;
  }

  protected override _label(): TemplateResult<1 | 2> {
    return html`
      ${this.icon()}
      ${typeof this.label === 'string'
        ? this.small
          ? html` <cr-text bold> ${this.label} </cr-text> `
          : html` <cr-h4> ${this.label} </cr-h4> `
        : this.label}
    `;
  }
}
